import { RuleRunCriteriaField } from "@rebuild/shared";
import { InputFieldProps } from "./types";
import { GenericRuleRunCriteriaInput } from "../GenericInputComponents";
import { useCarriers } from "../../../hooks/useCarriers";

export const CarrierInput: React.FC<InputFieldProps> = ({ inputField, inputValue, onUpdate: _onUpdate }) => {
	if (inputField.type !== "carriers") {
		return <>non-tpa types are currently not supported</>;
	}

	const carrierCriteriaList = inputValue as RuleRunCriteriaField | undefined;

	const { carriers } = useCarriers();

	return (
		<GenericRuleRunCriteriaInput
			ruleRunCriteriaList={carrierCriteriaList}
			options={carriers}
			getDisplayValue={(carrier) => carrier.name}
			getObjId={(carrier) => carrier.id}
			onUpdate={(newValue) => _onUpdate?.(newValue)}
		/>
	);
};
